import React, { ReactNode } from "react";

import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { VStack } from "@UI/Components/Stack/Stack";
import { Button } from "@UI/Components/Button/Button";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import useI18n from "@I18n/hooks/useI18n";
import messages from "../messages";

export interface IConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string | ReactNode;
  actionText?: string;
  cancelActionText?: string;
  isLoading?: boolean;
  closeOnAction?: boolean;
  onAction: () => void;
  onClose: () => void;
  closeOnOverlayClick?: boolean;
}

export const ConfirmationModal = (props: IConfirmationModalProps) => {
  const { formatMessage } = useI18n();
  const {
    isOpen,
    title,
    message,
    actionText = formatMessage(messages["confirm"]),
    cancelActionText = formatMessage(messages["cancel"]),
    isLoading,
    closeOnAction = true,
    onAction,
    onClose,
    closeOnOverlayClick = true,
  } = props;

  const closeBeforeAction = () => {
    closeOnAction && onClose();
    onAction();
  };
  return (
    <ResponsiveModal
      closeOnOverlayClick={closeOnOverlayClick}
      closeOnEsc={closeOnOverlayClick}
      isOpen={isOpen}
      onClose={isLoading ? () => null : onClose}
    >
      <VStack w="full" spacing="16px" mb="12px" alignItems="start">
        <Heading fontSize="2xl">{title}</Heading>

        {typeof message === "string" ? (
          <Text fontSize="md">{message}</Text>
        ) : (
          message
        )}

        <VStack w="full" spacing="8px" pt="4px">
          <Button
            w="inherit"
            size="lg"
            isDisabled={isLoading}
            isLoading={isLoading}
            onClick={closeBeforeAction}
            colorScheme="seaGreen"
          >
            {actionText}
          </Button>
          <Button
            w="inherit"
            size="lg"
            background="gray.300"
            _hover={{ background: "gray.400", color: "gray.800" }}
            isDisabled={isLoading}
            onClick={onClose}
          >
            {cancelActionText}
          </Button>
        </VStack>
      </VStack>
    </ResponsiveModal>
  );
};
